import React from 'react';

export default function ProjectList() {
  const projects = [
    {
      id: 1,
      title: "INDUSTRIAL HOOD",
      description: "Down Draft Hoods - Water Mist Hood - UV Hood - Odor Control Hood - Condensate Hood",
      image: "/assets/kitchenhood.png"
    },
    {
      id: 2,
      title: "INDUSTRIAL DISHWASHERS",
      description: "Utensilwashers - Rack conveyor dishwashers- Flight type dishwashers - Hood-type dishwashers- Under counter dishwashers",
      image: "/assets/dishwasher.png"
    },
    {
      id: 3,
      title: "INDUSTRIAL REFRIGERATION",
      description: "Bar Refrigeration - Chef Bases - Reach-In Refrigeration -Ice machines - Under counters & Worktops - Food Prep Tables",
      image: "/assets/refrigeration.png"
    },
    {
      id: 4,
      title: "HOT & COLD CABINETS ",
      description: "Hot Cabinet - Hot Banquet Trolley - Cold Banquet Trolley",
      image: "/assets/hot_&_cold.png"
    },
    {
      id: 5,
      title: "FOOD WASTE DISPOSER",
      description: "Standalone Series - Tabletop Series",
      image: "/assets/disposer.jpeg"
    },
    {
      id: 6,
      title: "MARIN GALLEY EQUIPMENTS",
      description: "We provide a diverse section of commercial marine gallery equipment to both our domestic and international marine clients",
      image: "https://www.globalialogisticsnetwork.com/blog/wp-content/uploads/2022/12/new-gen-2.png"
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Header Section */}
      <div className="relative text-white py-24">
        {/* Background Image with Blur */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url('./assets/products_head.jpg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'blur(1px)', // Blur only the background image
            WebkitFilter: 'blur(1px)', // For browser compatibility
          }}
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>
        {/* Text Content */}
        <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-5xl font-extrabold mb-4">Our Signature Products</h1>
          <p className="text-md max-w-3xl mx-auto opacity-90">
            As the foremost distributors in the industry, Northern Professional serves as your comprehensive source for all commercial kitchen and catering equipment needs. To uphold our competitive advantage and market dominance, we ensure a broad inventory of your favorite brands. We recognize that each kitchen has unique requirements; the variety of our products enables our clients to enhance workflow efficiency, reduce labor costs, maximize space utilization, and support business growth.
          </p>
        </div>
      </div>

      {/* Projects Grid */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-10">
          {projects.map((project) => (
            <div
              key={project.id}
              className="relative bg-white rounded-xl shadow-lg overflow-hidden group transform transition-all duration-500 hover:shadow-2xl hover:-translate-y-2"
            >
              {/* Image with Gradient Overlay */}
              <div className="relative h-64 sm:h-72">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 transition-opacity duration-300"></div>
              </div>

              {/* Content */}
              <div className="p-3">
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">{project.title}</h3>
                <p className="text-gray-600 mb-4 line-clamp-3 text-sm">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}